/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import moment from 'moment';
import { getTimeFormat } from '../../../Shared/Utilities/utils';
import { WEEK_DAY_SHORT_NAMES } from '../../../Shared/Constants/App';

export const formatDate = (dateValue: string): string => {
  return moment(dateValue).format('MMM DD, YYYY');
};

export const getMdScheduleTypeFromFrequency = (frequency: { mdScheduleType: string; scheduleDays: string }): string => {
  if (frequency.mdScheduleType === 'Monthly') {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `Day ${frequency.scheduleDays.split(',').join(', ')}`;
  } else if (frequency.mdScheduleType === 'Weekly') {
    // scheduleDays holds either day names ("Monday,Friday") or day indexes ("1,5").
    return frequency.scheduleDays
      .split(',')
      .map((day: string) => day.trim())
      .filter(Boolean)
      .map((day: string) => (/^\d$/.test(day) ? WEEK_DAY_SHORT_NAMES[Number(day)] : day.substring(0, 3)))
      .join(', ');
  }
  return '';
};

// Readable schedule pattern for a job frequency, e.g. "Mon, Fri · 8:00 PM - 10:00 PM".
export const getSchedulePattern = (frequency: {
  mdScheduleType?: string | null;
  scheduleDays?: string | null;
  fromTime?: string | null;
  toTime?: string | null;
}): string => {
  const days = getMdScheduleTypeFromFrequency({
    mdScheduleType: frequency?.mdScheduleType ?? '',
    scheduleDays: frequency?.scheduleDays ?? '',
  });
  const timing =
    frequency?.fromTime && frequency?.toTime
      ? `${getTimeFormat(frequency.fromTime)} - ${getTimeFormat(frequency.toTime)}`
      : '';
  return [days, timing].filter(Boolean).join(' · ');
};
